export default class BCMSDate {
	
	//Static variables used for formating dates into strings
	static shortDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	static longDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	static shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	static longMonth = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
		
	//CONSTRUCTOR ::  DATE|bcmsDate|[NUMBER:Day,NUMBER:Month,NUMBER:Year]|VOID -> this
	constructor(date) {	
		//initilize the date as a new Date 	
		this.date = date;	
	};

	// :: bcmsDate -> BOOLEAN
	// opperates a passed function on stored date and passed date
	// NOTE: Zeros out time to compare
	compare(bcmsDate, fn) {
		if(bcmsDate instanceof BCMSDate){			
			let fromDate = BCMSDate.normalize(this).getTime();
			let toDate = BCMSDate.normalize(bcmsDate).getTime();
		
			return fn(fromDate, toDate);
		}		
		throw new Error(`BCMSDate compare expected an instance of BCMSDate  was passed "${bcmsDate}"`);
	};

	// :: bcmsDate -> BOOLEAN
	// checks if stored date is less than passed date
	// NOTE: Zeros out time to compare
	isBefore(bcmsDate) {
		if(bcmsDate instanceof BCMSDate){
			return this.compare(bcmsDate, (fromDate, toDate) => fromDate < toDate);
		}		
		throw new Error(`BCMSDate isBefore expected an instance of BCMSDate  was passed "${bcmsDate}"`);

	};

	// :: bcmsDate -> BOOLEAN
	// checks if stored date is greater then passed date
	// NOTE: Zeros out time to compare
	isAfter(bcmsDate) {
		if(bcmsDate instanceof BCMSDate){
			return this.compare(bcmsDate, (fromDate, toDate) => fromDate > toDate);
		}		
		throw new Error(`BCMSDate isAfter expected an instance of BCMSDate  was passed "${bcmsDate}"`);	
	};

	// :: VOID -> BOOLEAN
	// checks if stored date less then today
	// NOTE: Zeros out time to compare
	isPast() {		
			return this.isBefore(BCMSDate.init());
	};

	// :: VOID -> BOOLEAN
	// checks if stored date is greater then today
	// NOTE: Zeros out time to compare
	isFuture() {		
		return this.isAfter(BCMSDate.init());		
	};

	// :: bcmsDate -> BOOLEAN
	// checks if stored date is equal to passed date
	// NOTE: Zeros out time to compare
	isEqual(bcmsDate) {
		if(bcmsDate instanceof BCMSDate){
			return this.compare(bcmsDate, function(fromDate, toDate){	
				return fromDate === toDate
			});
		}		
		throw new Error(`BCMSDate isEqual expected an instance of BCMSDate  was passed "${bcmsDate}"`);
	};
	
	// :: VOID -> BOOLEAN
	// Checks if stored date is equal to today
	isToday() {		
		return this.isEqual(BCMSDate.init());
	};

	// :: VOID -> BOOLEAN
	// returns true if stored date is a weekend
	isWeekend() {
		return this.date.getDay() === 0 || this.date.getDay() === 6;
	};

	// :: VOID -> BOOLEAN
	// returns true if stored date is a weekday
	isWeekDay() {
		return this.date.getDay() !== 0 && this.date.getDay() !== 6;
	};

	// :: NUMBER | [NUMBER:Day,NUMBER:Month,NUMBER:Year] -> this
	// Offsets stored date by given number of days:
	// NOTE: Negative number will set that many days in the past
	offset(value) {
		if (value instanceof Array) {
			if (value.length === 3) {
				let [day, month, year] = value;
				return this.offsetDay(day).offsetMonth(month).offsetYear(year);
			}
			throw new Error(`BCMSDate expected an array with a length of 3 "[day,month,year]" was given array with length "${value.length}"`);

		}
		return this.offsetDay(value)
	};

	// :: [NUMBER:Hour,NUMBER:Minute,NUMBER:Second] -> this
	// Offsets stored date by given number of days:
	// NOTE: Negative number will set that many days in the past
	offsetTime(value) {
		if (value instanceof Array) {
			if (value.length === 3) {
				let [hour, min, sec] = value;
				return this.offsetHours(hour).offsetMinutes(min).offsetSeconds(sec);
			}
			throw new Error(`BCMSDate expected an array with a length of 3 "[hour,min,second]" was given array with length "${value.length}"`);

		}
		return this.offsetHours(value)
	};

	// :: NUMBER -> this
	// Offsets stored date by given number of days:
	// NOTE: Negative number will set that many days in the past
	offsetDay(value) {
		if (!isNaN(value)) {
			this.day = this.dayInt + parseInt(value);
			return this;
		} 

		throw new Error(`BCMSDate.offsetDay given non-integer value "${value}"`);

	};

	// :: NUMBER -> this
	// Offsets stored date by given number of months:
	// NOTE: Negative number will set that many months in the past
	offsetMonth(value) {

		if (!isNaN(value)) {
			this.month = this.monthInt + parseInt(value);
			return this;
		}

		throw new Error(`BCMSDate.offsetMonth given non-integer value "${value}"`);

	};
	
	// :: NUMBER -> this
	// Offsets stored date by given number of Year:
	// NOTE: Negative number will set that many Years in the past
	offsetYear(value) {

		if (!isNaN(value)) {
			this.year = this.yearInt + parseInt(value);
			return this;
		}

		throw new Error(`BCMSDate.offsetYear given non-integer value "${value}"`);

	};

	// :: NUMBER -> this
	// Offsets stored date by given number of Hours:
	// NOTE: Negative number will set that many Hours in the past
	offsetHours(value) {

		if (!isNaN(value)) {
			this.hours =this.hoursInt + parseInt(value);
			return this;
		} else if (value === "c") {
			return this;
		}


		throw new Error(`BCMSDate.offsetHours given non-integer value "${value}"`);

	};

	// :: NUMBER -> this
	// Offsets stored date by given number of minutes:
	// NOTE: Negative number will set that many minutes in the past
	offsetMinutes(value) {
		if (!isNaN(value)) {
			this.minutes =this.minutesInt + parseInt(value);
			return this;
		}

		throw new Error(`BCMSDate.offsetMinutes given non-integer value "${value}"`);

	};

	// :: NUMBER -> this
	// Offsets stored date by given number of Seconds:
	// NOTE: Negative number will set that many Seconds in the past
	offsetSeconds(value) {

		if (!isNaN(value)) {
			this.seconds = this.secondsInt + parseInt(value);
			return this;
		}

		throw new Error(`BCMSDate.offsetSeconds given non-integer value "${value}"`);
		

	};



	// :: VOID | bcmsDate -> NUMBER
	// Returns the day offset for stored date from current Date or date passed
	diff(value) {
		
		if(value instanceof BCMSDate){
			let offset = value;
			return parseInt((BCMSDate.normalize(this) - BCMSDate.normalize(offset)) / (1000 * 60 * 60 * 24))
		}else{		
			let offset = BCMSDate.init()
			return parseInt((BCMSDate.normalize(this)- BCMSDate.normalize(offset)) / (1000 * 60 * 60 * 24))
		}		
		throw new Error(`BCMSDate compare expected an instance of BCMSDate  was passed "${value}"`);
		
	};

	// :: VOID -> this
	// offsets day untill next business day
	nextBusinessDay() {
		do{
			this.offset(1)
		}while(this.isWeekend());
		
		return  this;
	};

	// :: NUMBER -> this
	// offsets day until next day matches argument
	nextDate(day) {
		do{
			this.offset(1)
		}while(this.dayInt !== day);
		return this;
	};

	// :: VOID -> this
	// sets stored date to the first day of month
	setToFirst(){
		this.day =1;
		return this;
	};

	// :: VOID -> this
	// sets stored date to the last day of current month
	setToLast() {
		let tempMonth = this.date.getMonth() + 1;
		let tempDate = new Date(this.date.getFullYear(), tempMonth, 0);
		this.day = tempDate.getDate();
		return this;
	};

	// :: STRING -> STRING
	// Formats stored date using the passed format template:
	//Note: if unknown character is in template character is returned unchanged
	format(format) {
		let result = "";
		
		let escapeChar = false;
		for (let char of format ?? "m-d-y") {

			if (escapeChar === false) {
				switch (char) {
					
					case "j": result += this.dayInt;//  Day of month no leading 0s:
						break;
					case "d": result += BCMSDate.addLeadingZero(this.dayInt);							//  Day of month with leading 0s:
						break;
					case "o": result += this.dayInt + BCMSDate.ordinal(this.dayInt);// Add ordinal indicators to the day 1st, 2nd.3rd,4th:
						break;
					case "D": result += BCMSDate.shortDay[this.date.getDay()];//A textual representation of a day, three letters
						break;
					case "l": result += BCMSDate.longDay[this.date.getDay()];//A full textual representation of the day of the week
						break;
					case "n": result += this.monthInt;	//Numeric representation of a month, without leading zeros
						break;
					case "m": result += BCMSDate.addLeadingZero(this.monthInt);	//Numeric representation of a month, with leading zeros
						break;
					case "M": result += BCMSDate.shortMonth[this.monthInt-1];//A short textual representation of a month, three letters
						break;
					case "F": result += BCMSDate.longMonth[this.monthInt-1];//A full textual representation of a month, such as January or March
						break;
					case "Y": result += this.yearInt;//A full numeric representation of a year, 4 digits
						break;
					case "y": result += this.yearInt.toString().substr(-2);//A two digit representation of a year
						break;
					case "G": result += BCMSDate.addLeadingZero(this.date.getHours());//24-hour format of an hour with leading zeros
						break;
					case "H": result += BCMSDate.addLeadingZero(this.date.getHours());//24-hour format of an hour with leading zeros
						break;
					case "g": result += this.date.getHours() > 12 ? this.date.getHours() - 12 : this.date.getHours();// 12-hour format of an hour without leading zeros
						break;
					case "h": result += this.getStandardHour;	//12-hour format of an with leading zeros
						break;
					case "i": result += BCMSDate.addLeadingZero(this.date.getMinutes());//Minutes with leading zeros
						break;
					case "s": result += BCMSDate.addLeadingZero(this.date.getSeconds());//Seconds with leading zeros
						break;
					case "p": result += this.date.getHours() > 11 ? "PM" : "AM";//Appends the period for the time
						break;
					case "\\": escapeChar = true;
						break;
					default:
						result += char;
				}
			} else {
				result += char;
				escapeChar = false;
			}


		}
		return result;
	};

	/**
	 *
	 * Static:
	 *
	 */

	// :: DATE|bcmsDate|[NUMBER:Day,NUMBER:Month,NUMBER:Year]|VOID -> BCMSDate
	// Returns stored:
	static init(date) {
		return new BCMSDate(date);
	}
	
	// :: NUMBER -> STRING
	// Appends ordinal strings to the end of the number for formating
	static ordinal(d) {
		if (d > 3 && d < 21) return 'th';
		switch (d % 10) {
			case 1: return "st";
			case 2: return "nd";
			case 3: return "rd";
			default: return "th";
		}
	}
	
	// :: NUMBER -> STRING
	// Adds a leading "0" if needed to given integer:
	static addLeadingZero(n) {
		return n.toString().length < 2 ? "0" + n : n;
	};
	
	// :: bcmsDate -> normalize
	// sets the time of date to 0s for compareisons:
	static normalize(bcmsDate) {
		if(bcmsDate instanceof BCMSDate){	
			let tempDate = new Date(bcmsDate.date).setHours(0, 0, 0, 0);
			return new Date(tempDate);
		}
			throw new Error(`BCMSDate normalize expected an instance of BCMSDate  was passed  "${bcmsDate}"`);
		
	};

	/**
	 *
	 * Getters:
	 *
	 */

	// :: VOID -> DATE
	// Returns stored:
	get date() {
		return this._date;
	}

	// :: VOID -> NUMBER
	// Returns day of stored date as integer:
	// NOTE: If stored date is "1/2/33" then "2" is returned
	get dayInt() {
		return parseInt(this._date.getDate());
	}

	// :: VOID -> NUMBER
	// Returns month of stored date as integer:
	// NOTE: If stored date is "1/2/33" then "1" is returned
	get monthInt() {
		return parseInt(this._date.getMonth())+1;
	}

	// :: VOID -> NUMBER
	// Returns month of stored date as integer:
	// NOTE: If stored date is "1/2/33" then "1" is returned
	get yearInt() {
		return parseInt(this._date.getFullYear());
	}

	// :: VOID -> NUMBER
	// Returns day of stored date as integer:
	// NOTE: If stored date is "1/2/33" then "2" is returned
	get hoursInt() {
		return parseInt(this._date.getHours());
	}

	// :: VOID -> NUMBER
	// Returns month of stored date as integer:
	// NOTE: If stored date is "1/2/33" then "1" is returned
	get minutesInt() {
		return parseInt(this._date.getMinutes());
	}

	// :: VOID -> NUMBER
	// Returns month of stored date as integer:
	// NOTE: If stored date is "1/2/33" then "1" is returned
	get secondsInt() {
		return parseInt(this._date.getSeconds());
	}

	// :: VOID -> STRING
	// Returns month of stored date as integer:
	// NOTE: If stored date is "1/2/33" then "1" is returned
	get getStandardHour() {
		return this.date.getHours() > 12 ? this.date.getHours() - 12 : this._date.getHours();
		
	}

	// :: VOID -> STRING
	// Returns Day of week of stored date as string:
	get getLongDay() {
		return this.format("l")
	}

	// :: VOID -> STRING
	// Returns Day of week of stored date as string:
	get getShortDay() {
		return this.format("D")
	}

	// :: VOID -> STRING
	// Returns Name of month of stored date as string:
	// NOTE: If stored date is "1/2/33" then "January" is returned
	get getLongMonth() {
		return this.format("F")
	}

	// :: VOID -> STRING
	//Returns name of month of stored date as string:
	// NOTE: If stored date is "1/2/33" then "Jan" is returned
	get getShortMonth() {
		return this.format("M")
	}

	/**
	 *
	 * Setters:
	 *
	 */
	// ::DATE |[NUMBER:Day,NUMBER:Month,NUMBER:Year] -> this
	// sets the time of stored date
	

	set date(date) {
		if(date){
			if(date instanceof Date){
				this._date = new Date(date);
			}
			else if(date instanceof BCMSDate){
				this._date = new Date(date.date);
			}
			else if (date instanceof Array) {
				if (date.length === 3) {
					this._date = new Date();
					let [day, month, year] = date;
					this.day = day;
					this.month = month;
					this.year = year;
				}else{							
					throw new Error(`BCMSDate expected an array with a length of 3 "[day,month,year]" was given array with length "${date.length}"`);
				}	
			}else{
				throw new Error(`BCMSDate constructor expected an instance of Date was passed "${date}"`)
			}
		}
		else{
			this._date =  new Date();
		}
		
		return this;
	}


	// :: [NUMBER:Hour,NUMBER:Minute,NUMBER:Second] -> this
	// sets the time of stored date
	set time(value) {
		if (value instanceof Array) {
			if (value.length === 3) {
				let [hour, min, sec] = value;
				 this.hours =hour;
				 this.minutes =min;
				 this.seconds = sec;
				 return this;
			}
		}
		throw new Error(`BCMSDate expected an array with a length of 3 "[hour,min,second]" was given array with length "${value.length}"`);

	};
		// :: NUMBER -> this
	// Sets hours
	// NOTE: numbers over 23 will offset day.
	set day(value) {

		if (!isNaN(value)) {
			this.date.setDate(value);			
		} 
		return this;
	};

	// :: NUMBER -> this
	// sets the minutes:
	// NOTE: passing number greater then 59 will offset hours
	set month(value) {

		if (!isNaN(value)) {
			this.date.setMonth((value -1));
		
		} 
		return this;
	};

	// :: NUMBER -> this
	// sets the seconds:
	// NOTE: passing number greater then 59 will offset minutes
	set year(value) {

		if (!isNaN(value)) {
			this.date.setFullYear(value);			
		}

		return this;
		
	};
	
	// :: NUMBER -> this
	// Sets hours
	// NOTE: numbers over 23 will offset day.
	set hours(value) {

		if (!isNaN(value)) {
			this.date.setHours(value);		
		}
			
			return this;
		

	};

	// :: NUMBER -> this
	// sets the minutes:
	// NOTE: passing number greater then 59 will offset hours
	set minutes(value) {
		if (!isNaN(value)) {
			this.date.setMinutes(value);			
		} 
			return this;
		

	};

	// :: NUMBER -> this
	// sets the seconds:
	// NOTE: passing number greater then 59 will offset minutes
	set seconds(value) {

		if (!isNaN(value)) {
			this.date.setSeconds(parseInt(value));			
		}
			return this;
		

	};
}
